function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
import { isAdani, isReloy } from "../../../../../../utils/isClient";
import VideoModal from "../../../../../Common/VideoModal";
import { coin } from "../../../DealsLayout/svg";
import { giftSvg } from "../../svg";
import BsInfoCircle from "@meronex/icons/bs/BsInfoCircle";
import { useState, useEffect } from "react";
import ReactPlayer from "react-player";
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
export function RewardsHeaderLayout(props) {
  var _config$deals, _config$deals2;
  var searchValue = props.searchValue,
    onSearchChange = props.onSearchChange,
    internalWebview = props.internalWebview,
    userAccountSummary = props.userAccountSummary,
    kycStatus = props.kycStatus,
    config = props.config,
    isAuthenticated = props.isAuthenticated,
    backgroundClass = props.backgroundClass,
    textColorClass = props.textColorClass,
    buttonBg = props.buttonBg,
    totalPoints = props.totalPoints,
    kycCompleted = props.kycCompleted,
    kycNotCompleted = props.kycNotCompleted,
    playKYCVideo = props.playKYCVideo,
    setPlayKYCVideo = props.setPlayKYCVideo,
    claimCTA = props.claimCTA,
    handleRedeemClick = props.handleRedeemClick,
    appType = props.appType,
    _props$redux = props.redux,
    redux = _props$redux === void 0 ? {} : _props$redux,
    _props$isPoints = props.isPoints,
    isPoints = _props$isPoints === void 0 ? false : _props$isPoints,
    history = props.history;
  var _useState = useState(false),
    _useState2 = _slicedToArray(_useState, 2),
    isMobile = _useState2[0],
    setIsMobile = _useState2[1];
  var dispatch = redux === null || redux === void 0 ? void 0 : redux.dispatch;
  var authActions = redux === null || redux === void 0 ? void 0 : redux.authActions;
  useEffect(function () {
    var handleResize = function handleResize() {
      setIsMobile(window.innerWidth < 1024); // lg breakpoint
    };
    handleResize(); // Initial check
    window.addEventListener("resize", handleResize);
    return function () {
      return window.removeEventListener("resize", handleResize);
    };
  }, []);
  var bgUrl = isMobile ? "https://cdn.loyalie.in/1774367746480_Ledger_B1M" : "https://cdn.loyalie.in/1774257142945_LedgerB2W";
  var formattedReloyPoints = Number((userAccountSummary === null || userAccountSummary === void 0 ? void 0 : userAccountSummary.reloyRewardPoints) || 0).toLocaleString("en-IN");
  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [/*#__PURE__*/_jsxs("div", {
      className: "flex flex-col lg:flex-row gap-x-5 cursor-pointer ".concat(isPoints ? "h-full lg:h-[45vh]" : ""),
      children: [/*#__PURE__*/_jsx("div", {
        className: "w-full lg:w-[80%] xl:w-[75%] 2xl:w-[80%] text-white  ".concat(internalWebview ? "sticky top-0 z-10 bg-white py-1 " : ""),
        children: /*#__PURE__*/_jsx("div", {
          className: "w-full ".concat(internalWebview ? "mt-16" : "lg:mt-0"),
          children: isPoints ? /*#__PURE__*/_jsxs("div", {
            className: "relative",
            children: [/*#__PURE__*/_jsx("img", {
              className: "w-full h-[50vh] lg:h-[45vh] rounded-xl object-fill cursor-default",
              src: config !== null && config !== void 0 && config.darkTheme ? isMobile ? "https://cdn.loyalie.in/1778748496079_darkTheme-Mob" : "https://cdn.loyalie.in/1778748178420_darkThemeBanner" : isMobile ? "https://cdn.loyalie.in/1778749406084_darkTheme-Banner" : "https://cdn.loyalie.in/1778749311619_lightMode-Banner",
              alt: "Points Banner"
            }), /*#__PURE__*/_jsx("div", {
              className: "absolute inset-0 flex items-center lg:mx-0 px-4 lg:px-16 -mt-56  lg:-mt-0 ".concat(isMobile ? "justify-center text-center" : "justify-start text-left"),
              children: /*#__PURE__*/_jsxs("h1", {
                className: "".concat(config === null || config === void 0 ? void 0 : config.fontTitle, " text-2xl lg:text-4xl leading-tight ").concat(config !== null && config !== void 0 && config.darkTheme ? "text-transparent bg-clip-text" : "text-primary"),
                style: config !== null && config !== void 0 && config.darkTheme ? {
                  backgroundImage: "linear-gradient(\n            90deg,\n            #fdc977 0%,\n            #feefd7 62%,\n            #ae8443 100%\n          )",
                  WebkitBackgroundClip: "text",
                  WebkitTextFillColor: "transparent"
                } : {},
                children: ["Welcome to ", /*#__PURE__*/_jsx("br", {}), " ", config === null || config === void 0 ? void 0 : config.programName, " Loyalty"]
              })
            })]
          }) :
          /*#__PURE__*/
          /* REWARDS BANNER */
          _jsx("div", {
            children: isAdani(config) ? /*#__PURE__*/_jsx("div", {
              className: "w-full h-full rounded-xl overflow-hidden cursor-default",
              children: /*#__PURE__*/_jsx(ReactPlayer, {
                url: isMobile ? "https://cdn.loyalie.in/connectre_website/RewardStore_Mobile.mp4" : "https://cdn.loyalie.in/connectre_website/RewardStore_Desktop.mp4",
                width: "100%",
                height: "100%",
                controls: false,
                light: false,
                autoPlay: true,
                playing: true,
                loop: true,
                muted: true
              })
            }) : /*#__PURE__*/_jsx("img", {
              className: "w-full h-full object-cover rounded-xl cursor-default",
              src: isMobile ? (config === null || config === void 0 || (_config$deals = config.deals) === null || _config$deals === void 0 || (_config$deals = _config$deals.rewardsBanner) === null || _config$deals === void 0 ? void 0 : _config$deals.backgroundImageMobile) || "https://reloy-internal.s3.ap-south-1.amazonaws.com/Gif/Aloha_Luxe%2BClub_RewardStore_Banner_SM.gif" : (config === null || config === void 0 || (_config$deals2 = config.deals) === null || _config$deals2 === void 0 || (_config$deals2 = _config$deals2.rewardsBanner) === null || _config$deals2 === void 0 ? void 0 : _config$deals2.backgroundImage) || "https://reloy-internal.s3.ap-south-1.amazonaws.com/Gif/Aloha_Luxe%2BClub_RewardStore_Banner_LG.gif",
              alt: "Rewards Banner"
            })
          })
        })
      }), isPoints ? /*#__PURE__*/_jsx("div", {
        className: "w-full lg:w-[30%] xl:w-[25%] 2xl:w-[24%] rounded-xl relative overflow-hidden ".concat(isPoints ? "h-auto lg:h-[45vh]" : "", " ").concat(internalWebview ? "mt-14" : "mt-4 lg:mt-0"),
        style: config !== null && config !== void 0 && config.darkTheme ? {
          backgroundImage: "url(\"".concat(bgUrl, "\")"),
          backgroundSize: "cover",
          backgroundPosition: "center",
          backgroundRepeat: "no-repeat"
        } : {
          background: config === null || config === void 0 ? void 0 : config.primaryColor
        },
        children: isAuthenticated ? /*#__PURE__*/_jsxs(_Fragment, {
          children: [/*#__PURE__*/_jsxs("div", {
            className: "flex lg:hidden items-center justify-between py-6  px-4 ".concat(config !== null && config !== void 0 && config.darkTheme ? 'text-black' : "text-white"),
            children: [/*#__PURE__*/_jsxs("div", {
              children: [/*#__PURE__*/_jsx("p", {
                className: "text-sm font-medium",
                children: "You have earned"
              }), /*#__PURE__*/_jsxs("p", {
                className: "text-2xl ".concat(config === null || config === void 0 ? void 0 : config.fontTitle, " font-medium leading-tight"),
                children: [(userAccountSummary === null || userAccountSummary === void 0 ? void 0 : userAccountSummary.reloyRewardPoints) != null ? userAccountSummary.reloyRewardPoints.toLocaleString("en-IN") : "0", " ", isReloy(config) ? 'HT Points' : 'Loyalty Coins']
              })]
            }), /*#__PURE__*/_jsx("div", {
              children: (userAccountSummary === null || userAccountSummary === void 0 ? void 0 : userAccountSummary.reloyRewardPoints) > 0 ? /*#__PURE__*/_jsxs("button", {
                onClick: handleRedeemClick,
                className: "py-2 px-4 text-xs font-medium rounded ".concat(config !== null && config !== void 0 && config.darkTheme ? 'border-[1px] border-black text-black' : "bg-white text-primary"),
                children: ["REDEEM ", isReloy(config) ? 'POINTS' : 'COINS']
              }) : /*#__PURE__*/_jsxs("button", {
                onClick: function onClick() {
                  return history.push(isReloy(config) ? '/refer' : '/gift-and-earn');
                },
                className: "py-2 px-4 text-xs font-medium rounded ".concat(config !== null && config !== void 0 && config.darkTheme ? 'border-[1px] border-black text-black' : "bg-white text-primary"),
                children: ["EARN ", isReloy(config) ? 'POINTS' : 'COINS']
              })
            })]
          }), /*#__PURE__*/_jsxs("div", {
            className: "hidden lg:flex absolute inset-0 flex-col justify-center p-6 xl:p-10 text-center md:text-left ".concat(config !== null && config !== void 0 && config.darkTheme ? 'text-black' : "text-white"),
            children: [/*#__PURE__*/_jsxs("div", {
              className: "space-y-1 lg:space-y-0 xl:space-y-1.5 pb-6",
              children: [/*#__PURE__*/_jsx("p", {
                className: "text-xl xl:text-2xl font-medium ",
                children: "You have earned"
              }), /*#__PURE__*/_jsxs("div", {
                className: "flex flex-row items-center  justify-center lg:items-start lg:flex-col",
                children: [/*#__PURE__*/_jsxs("p", {
                  className: "text-3xl lg:text-4xl xl:text-5xl tracking-wide ".concat(config === null || config === void 0 ? void 0 : config.fontTitle, " font-medium leading-[1]"),
                  children: [(userAccountSummary === null || userAccountSummary === void 0 ? void 0 : userAccountSummary.reloyRewardPoints) != null ? userAccountSummary.reloyRewardPoints.toLocaleString("en-IN") : "", " "]
                }), /*#__PURE__*/_jsx("p", {
                  className: "text-2xl xl:text-4xl ".concat(config === null || config === void 0 ? void 0 : config.fontTitle, " leading-[1] ml-2 lg:ml-0"),
                  children: isReloy(config) ? 'HT Points' : 'Loyalty Coins'
                })]
              })]
            }), /*#__PURE__*/_jsx("div", {
              children: (userAccountSummary === null || userAccountSummary === void 0 ? void 0 : userAccountSummary.reloyRewardPoints) > 0 ? /*#__PURE__*/_jsxs("button", {
                onClick: handleRedeemClick,
                className: " py-2  px-6 text-sm font-medium text-black rounded ".concat(config !== null && config !== void 0 && config.darkTheme ? "border-[1px] border-black  text-black" : "bg-white text-primary"),
                children: ["REDEEM  ", /*#__PURE__*/_jsx("span", {
                  children: isReloy(config) ? 'POINTS' : 'COINS'
                })]
              }) : /*#__PURE__*/_jsxs("button", {
                onClick: function onClick() {
                  return history.push(isReloy(config) ? '/refer' : '/gift-and-earn');
                },
                className: " py-2  px-4 text-sm font-medium text-black rounded ".concat(config !== null && config !== void 0 && config.darkTheme ? "border-[1px] border-black  text-black" : "bg-white text-primary"),
                children: ["EARN  ", /*#__PURE__*/_jsx("span", {
                  children: isReloy(config) ? 'POINTS' : 'COINS'
                })]
              })
            })]
          })]
        }) : /*#__PURE__*/_jsxs("div", {
          onClick: function onClick() {
            return dispatch && authActions !== null && authActions !== void 0 && authActions.openLoginModal ? dispatch(authActions.openLoginModal()) : null;
          },
          className: "absolute inset-0 flex flex-col justify-center p-6 xl:p-10 text-center md:text-left",
          children: [/*#__PURE__*/_jsx("div", {
            className: "space-y-1 lg:space-y-0 xl:space-y-1 pb-6",
            children: /*#__PURE__*/_jsxs("p", {
              className: "text-lg xl:text-xl font-medium ".concat(config !== null && config !== void 0 && config.darkTheme ? " text-black" : "text-white", "\n                  >"),
              children: ["Login to check your ", isReloy(config) ? 'HT Points' : 'Insider Coins']
            })
          }), /*#__PURE__*/_jsx("div", {
            children: /*#__PURE__*/_jsx("button", {
              className: "".concat(config !== null && config !== void 0 && config.darkTheme ? "border-[1px] border-black text-black" : "bg-white text-primary", " py-2  px-8  font-semibold rounded "),
              children: "Login"
            })
          })]
        })
      }) : /*#__PURE__*/_jsx("div", {
        className: "flex flex-col w-full lg:w-[30%] xl:w-[25%] 2xl:w-[24%] rounded-xl text-white ".concat(internalWebview ? "mt-14" : "mt-4 lg:mt-0", " justify-between px-5 py-10 lg:py-5 xl:py-10 ").concat(backgroundClass),
        children: /*#__PURE__*/_jsxs("div", {
          onClick: function onClick() {
            return !isAuthenticated && dispatch && authActions !== null && authActions !== void 0 && authActions.openLoginModal ? dispatch(authActions.openLoginModal()) : null;
          },
          className: "flex flex-col",
          children: [/*#__PURE__*/_jsxs("div", {
            className: " mt-2",
            children: [kycCompleted && isAuthenticated && /*#__PURE__*/_jsx("div", {
              className: "".concat(textColorClass),
              children: /*#__PURE__*/_jsxs("p", {
                className: "ml-2",
                children: ["\u2705 KYC Completed", totalPoints > 0 ? " – You're ready to redeem your rewards!" : ""]
              })
            }), !kycCompleted && isAuthenticated && totalPoints > 0 && /*#__PURE__*/_jsx("div", {
              className: "".concat(textColorClass),
              children: /*#__PURE__*/_jsx("p", {
                className: "ml-2",
                children: kycStatus === "PROCESSING" ? /*#__PURE__*/_jsx(_Fragment, {
                  children: "\u23F3 KYC under process."
                }) : /*#__PURE__*/_jsxs(_Fragment, {
                  children: [/*#__PURE__*/_jsx("div", {
                    className: "flex justify-end -mt-3 xl:-mt-5 mb-3 mr-2",
                    children: /*#__PURE__*/_jsx(BsInfoCircle, {
                      onClick: function onClick() {
                        return setPlayKYCVideo(true);
                      },
                      className: "cursor-pointer w-4 h-4 text-white font-bold"
                    })
                  }), /*#__PURE__*/_jsx("span", {
                    children: "\uD83D\uDEAB KYC Pending \u2013 Complete your verification to redeem your rewards."
                  })]
                })
              })
            })]
          }), /*#__PURE__*/_jsxs("div", {
            className: "flex flex-col  items-start w-full mt-6 ",
            children: [/*#__PURE__*/_jsxs("div", {
              className: "flex  items-center gap-1",
              children: [/*#__PURE__*/_jsx("div", {
                children: giftSvg
              }), /*#__PURE__*/_jsx("div", {
                className: "",
                children: /*#__PURE__*/_jsx("p", {
                  className: "lg:text-sm xl:text-base ml-2 ".concat(textColorClass),
                  children: isAuthenticated ? totalPoints <= 0 ? (userAccountSummary === null || userAccountSummary === void 0 ? void 0 : userAccountSummary.claimedRewardPoints) > 0 ? "You have claimed your rewards. Refer now to earn more rewards!" : "You don't have Rewards to claim" : "You have rewards waiting for you" : "Login to check Rewards eligibility"
                })
              })]
            }), !isAuthenticated && /*#__PURE__*/_jsx("button", {
              onClick: function onClick() {
                return dispatch && authActions !== null && authActions !== void 0 && authActions.openLoginModal ? dispatch(authActions.openLoginModal()) : null;
              },
              className: "".concat(config !== null && config !== void 0 && config.darkTheme ? "border-[1px] border-black ".concat(buttonBg, " ").concat(textColorClass) : "bg-white text-primary", " mt-4 lg:mt-5 xl:mt-8  py-2  px-8 rounded font-semibold ml-1"),
              children: "Login"
            }), isAuthenticated && (totalPoints > 0 && kycCompleted ? /*#__PURE__*/_jsx("button", {
              onClick: handleRedeemClick,
              className: "".concat(config !== null && config !== void 0 && config.darkTheme ? "border-[1px] border-black ".concat(buttonBg, " ").concat(textColorClass) : "bg-white text-primary", " mt-4 lg:mt-5 xl:mt-8  py-2  px-8 rounded font-semibold ml-1"),
              children: "Redeem Now"
            }) : totalPoints <= 0 ? appType === "winnre" ? null : /*#__PURE__*/_jsx("button", {
              onClick: claimCTA,
              className: "".concat(config !== null && config !== void 0 && config.darkTheme ? "border-[1px] border-black ".concat(buttonBg, " ").concat(textColorClass) : "bg-white text-primary", " mt-4 lg:mt-5 xl:mt-8  py-2  px-8 rounded font-semibold ml-1"),
              children: "Refer Now"
            }) : /*#__PURE__*/_jsx("button", {
              onClick: claimCTA,
              className: "".concat(config !== null && config !== void 0 && config.darkTheme ? "border-[1px] border-black ".concat(buttonBg, " ").concat(textColorClass) : "bg-white text-primary", " mt-4 lg:mt-5 xl:mt-8  py-2  px-8 rounded font-semibold ml-1"),
              children: "COMPLETE KYC"
            }))]
          })]
        })
      })]
    }), /*#__PURE__*/_jsx(VideoModal, {
      isVisible: playKYCVideo,
      setIsVisible: setPlayKYCVideo,
      videoUrl: "https://www.youtube.com/shorts/yGU-AIZlxw8"
    })]
  });
}